









































import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// EnumsData
import { ListDisplayMode } from "@/data/constants";

// Types
import { ICatalogueProductListData } from "@/models/providers/catalogueProducts";

@Component({
  components: {
    "product-list-item-switcher": () =>
      import(
        "@/components/app/admin/catalogue/products/listing/productListItemSwitcher.vue"
      )
  }
})
export default class ProductsViewSwitcher extends Vue {
  // Inject - Products provider data

  @Inject({ from: "catalogueProductListData" })
  public readonly $catalogueProductListData!: () => ICatalogueProductListData;

  public get $productListData() {
    return this.$catalogueProductListData();
  }

  // Props

  @Prop({ default: ListDisplayMode.GRID })
  public displayMode!: ListDisplayMode;

  // Computed

  public get isGridView() {
    return this.displayMode === ListDisplayMode.GRID;
  }

  public get skeletonSize() {
    const { data } = this.$productListData.table;
    if (data.length) return data.length;
    if (!this.isGridView) return this.$store.getters["ui/isMobile"] ? 2 : 5;
    return this.$store.getters["ui/isMobile"]
      ? 2
      : this.$store.getters["isAdminContext"]
      ? this.$store.getters["ui/isFullHd"]
        ? this.$store.state.ui.nav.isCollapsed
          ? 12
          : 9
        : 6
      : 4;
  }

  public get showEmptyState() {
    return (
      !this.$productListData.isLoading &&
      !this.$productListData.table.data.length
    );
  }

  public get showSkeletons() {
    return this.$productListData.isLoading || !this.$productListData.total;
  }
}
